import { Phone, MapPin, Clock, Mail } from "lucide-react";
import { PHONE, PHONE_DISPLAY, ADDRESS, HOURS, EMAIL } from "@/lib/site";
import { Eyebrow, Reveal, WaButton } from "./ui";

const INFO = [
  { icon: Phone, label: "Telefoni", value: PHONE_DISPLAY, href: `tel:${PHONE}` },
  { icon: MapPin, label: "Punëtoria", value: ADDRESS },
  { icon: Clock, label: "Orari", value: HOURS },
  { icon: Mail, label: "Email", value: EMAIL },
];

export const Contatti = () => (
  <section id="contatti" className="relative bg-[#0B0B0C] py-24 sm:py-36 overflow-hidden" data-testid="contact-section">
    <img src="/img/nero-assoluto.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0B0B0C] via-[#0B0B0C]/85 to-[#0B0B0C]/60" />
    <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14">
      <Reveal className="lg:col-span-7">
        <Eyebrow>Ofertë falas</Eyebrow>
        <h2 className="font-display font-light text-5xl sm:text-7xl lg:text-[6.5rem] text-[#F3EEE4] mt-6 leading-[0.95]">
          Na tregoni <br className="hidden sm:block" />për <em className="text-gold-grad">projektin</em> tuaj.
        </h2>
        <p className="mt-8 text-[#CFC8BA] text-base md:text-lg max-w-lg leading-relaxed">
          Na dërgoni masat, foto ose një ide në WhatsApp, ose na telefononi: ju përgjigjemi me një propozim materiali dhe një ofertë.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <WaButton testId="contact-whatsapp-cta" label="Na shkruani në WhatsApp" />
          <a href={`tel:${PHONE}`} data-testid="contact-call-cta" className="btn-ghost inline-flex items-center gap-3 rounded-full px-7 py-4 text-sm tracking-wide text-[#F3EEE4]">
            <Phone className="w-4 h-4" /> Telefononi tani
          </a>
        </div>
      </Reveal>
      <Reveal delay={0.15} className="lg:col-span-5 lg:pt-20">
        <ul className="divide-y divide-white/10 border-y border-white/10">
          {INFO.map(({ icon: Icon, label, value, href }) => (
            <li key={label} className="flex items-center gap-5 py-5" data-testid={`contact-info-${label.toLowerCase()}`}>
              <span className="w-11 h-11 rounded-full border border-[#C9A55C]/40 grid place-items-center text-[#C9A55C] shrink-0"><Icon className="w-4 h-4" /></span>
              <div>
                <p className="font-mono-x text-[11px] tracking-[0.25em] uppercase text-[#A8A196]">{label}</p>
                {href ? <a href={href} className="font-display text-2xl text-[#F3EEE4] hover:text-[#E3C88A] transition-colors">{value}</a> : <p className="font-display text-2xl text-[#F3EEE4]">{value}</p>}
              </div>
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);
